var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1405_187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8907 2.006L20.9967 2L21.1267 2.008L21.2167 2.024L21.3397 2.059L21.4467 2.105L21.5467 2.162L21.6367 2.229L21.7187 2.304L21.7707 2.363L21.8527 2.479L21.9047 2.575C21.9517 2.675 21.9817 2.781 21.9947 2.891L21.9997 2.997C21.9997 3.072 21.9917 3.146 21.9757 3.217L21.9407 3.34L15.4087 21.417C15.2849 21.6866 15.0863 21.9149 14.8365 22.075C14.5868 22.2351 14.2963 22.3201 13.9997 22.32C13.7325 22.3208 13.4697 22.2525 13.2368 22.1216C13.0039 21.9907 12.8088 21.8017 12.6707 21.573L12.6057 21.446L9.25369 14.744L2.58369 11.408C2.33689 11.2951 2.12405 11.1194 1.96646 10.8985C1.80887 10.6775 1.71205 10.4191 1.68569 10.149L1.67969 10C1.67969 9.44 1.98069 8.928 2.52069 8.63L2.66069 8.56L20.6777 2.054L20.7837 2.024L20.8907 2.006Z",
    fill: "#555555"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1405_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutLocation);
export default __webpack_public_path__ + "static/media/about_location.e6bf33039ef1eca9b1d29e8a1fc79cfa.svg";
export { ForwardRef as ReactComponent };